/**
 * Pinned game modes — persisted in localStorage.
 */

const KEY_MODE_PINS = "modePinsV1";

function readPinnedIds(): string[] {
    try {
        const raw = localStorage.getItem(KEY_MODE_PINS);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        const out: string[] = [];
        const seen = new Set<string>();
        for (const item of parsed) {
            const id = String(item || "").trim();
            if (!id || seen.has(id)) continue;
            seen.add(id);
            out.push(id);
        }
        return out;
    } catch {
        return [];
    }
}

function writePinnedIds(ids: string[]): void {
    try {
        localStorage.setItem(KEY_MODE_PINS, JSON.stringify(ids));
    } catch {
        /* ignore */
    }
}

export function getPinnedModeIds(): string[] {
    return readPinnedIds();
}

export function isModePinned(modeId: string | null | undefined): boolean {
    if (!modeId) return false;
    return readPinnedIds().includes(modeId);
}

export function pinMode(modeId: string): void {
    if (!modeId || isModePinned(modeId)) return;
    writePinnedIds([...readPinnedIds(), modeId]);
}

export function unpinMode(modeId: string): void {
    if (!modeId) return;
    writePinnedIds(readPinnedIds().filter((id) => id !== modeId));
}
